

























































































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class MetaNotes extends Vue {
  // COMPUTED
  get today() {
    return this.$store.state.metaData.date;
  }
  set today(newDate) {
    this.updateMeta("date", newDate);
  }

  get triviaLocation() {
    return this.$store.state.metaData.location;
  }
  set triviaLocation(newLoc) {
    this.updateMeta("location", newLoc);
  }

  get arrivalTime() {
    return this.$store.state.metaData.arrive;
  }
  set arrivalTime(newArrive) {
    this.updateMeta("arrive", newArrive);
  }

  get triviaStart() {
    return this.$store.state.metaData.start;
  }
  set triviaStart(newStart) {
    this.updateMeta("start", newStart);
  }

  get triviaEnd() {
    return this.$store.state.metaData.end;
  }
  set triviaEnd(newStart) {
    this.updateMeta("end", newStart);
  }

  get numTeams() {
    return this.$store.getters.numTeams;
  }
  set numTeams(newTeams) {
    this.updateMeta("teams", newTeams);
  }

  get numPlayers() {
    return this.$store.state.metaData.players;
  }
  set numPlayers(newPlayers) {
    this.updateMeta("players", newPlayers);
  }

  get mtTables() {
    return this.$store.state.metaData.empty;
  }
  set mtTables(newTables) {
    this.updateMeta("empty", newTables);
  }

  get quizRating() {
    return this.$store.state.metaData.quizRating;
  }
  set quizRating(newTables) {
    this.updateMeta("quizRating", newTables);
  }

  get otherNotes() {
    return this.$store.state.metaData.internal;
  }
  set otherNotes(newNote) {
    this.updateMeta("internal", newNote);
  }

  // METHODS
  select(arg: string) {
    const element: HTMLInputElement = document.getElementById(
      arg
    ) as HTMLInputElement;
    element.select();
  }
  updateMeta(note: string, newValue: string) {
    this.$store.commit("updateMeta", { noteToUpdate: note, value: newValue });
  }
}
